const bonusQuestions = [
  {
    id: 'bq_0',
    content: 'What country has an ATM with instructions in Latin?',
    date: '1/27',
  },
  {
    id: 'bq_1',
    content: 'What\'s the most popular brand of hard seltzer?',
    date: '2/3',
  },
  {
    id: 'bq_2',
    content: 'What official product does Victorinox make?',
    date: '2/10',
  },
  {
    id: 'bq_3',
    content: 'How many points does the Baha\'i star have?',
    date: '2/17',
  },
  {
    id: 'bq_4',
    content: 'What rodent is considered the friendliest animal on Earth?',
    date: '3/3',
  },
  {
    id: 'bq_5',
    content: 'What is the name for the world of men in Norse mythology?',
    date: '3/17',
  },
  {
    id: 'bq_6',
    content: 'Name any non-state territory of the United States that is not Puerto Rico.',
    date: '3/24',
  },
  {
    id: 'bq_7',
    content: 'Easter is celebrated on the first Sunday following the first full moon on or after what?',
    date: '3/31',
  },
  {
    id: 'bq_8',
    content: 'What\'s at 10 Downing Street?',
    date: '4/7',
  },
  {
    id: 'bq_9',
    content: 'What city, in the county of Surrey, do the Dursleys live in?',
    date: '4/14',
  },
  {
    id: 'bq_10',
    content: 'By what name is Samuel Clemens better known?',
    date: '4/21',
  },
  {
    id: 'bq_11',
    content: 'Who is Doug Bowser?',
    date: '4/28',
  },
  {
    id: 'bq_12',
    content: 'How many champions (within 5) are there with the release of Gwen?',
    date: '5/12',
  },
  {
    id: 'bq_13',
    content: 'What constellation is the Big Dipper part of?',
    date: '5/19',
  },
  {
    id: 'bq_14',
    content: 'What’s the order of colors in a rainbow?',
    date: '6/2',
  },
  {
    id: 'bq_15',
    content: 'What Greek hero is also JavaScript and detergent?',
    date: '6/16',
  },
  {
    id: 'bq_16',
    content: 'What Elvish port city do ships depart from for Aman, or the Blessed Lands?',
    date: '6/23',
  },
  {
    id: 'bq_17',
    content: 'Commander Shepard is the main character of what sci-fi video game franchise?',
    date: '6/30',
  },
  {
    id: 'bq_18',
    content: 'A former international chain of stores now only has one location left, in Bend, OR. What store?',
    date: '7/7',
  },
  {
    id: 'bq_19',
    content: 'What Pepsi-owned product accounts for 75% of the U.S. market share in sports drinks?',
    date: '8/24',
  },
  {
    id: 'bq_20',
    content: 'What’s the capital of Alaska?',
    date: '8/31',
  },
  {
    id: 'bq_21',
    content: 'What programming language is named after a sketch comedy group?',
    date: '9/7',
  },
  {
    id: 'bq_22',
    content: 'What kind of writing paper has lines as a guide?',
    date: '9/14',
  },
  {
    id: 'bq_23',
    content: 'What name is often given to the primordial female demon?',
    date: '9/21',
  },
  {
    id: 'bq_24',
    content: 'Oktoberfest is traditionally held in what German city?',
    date: '10/5',
  },
  {
    id: 'bq_25',
    content: 'What scary children’s book series was written by Alvin Schwartz?',
    date: '10/26',
  },
  {
    id: 'bq_26',
    content: 'What’s the only Minecraft enemy that can pick up blocks?',
    date: '11/2',
  },
  {
    id: 'bq_27',
    content: 'What two months were named after Roman emperors?',
    date: '11/9',
  },
  {
    id: 'bq_28',
    content: 'The evergreen shrub Vaccinium oxycoccus produces what acidic fruit?',
    date: '11/23',
  },
  {
    id: 'bq_29',
    content: 'What colors are on the Irish flag?',
    date: '11/30',
  },
  {
    id: 'bq_30',
    content: 'The shore of what salty lake is the lowest land-based point on Earth?',
    date: '12/14',
  },
  {
    id: 'bq_31',
    content: 'What color has hex value #FFFFFF?',
    date: '1/11',
  },
  {
    id: 'bq_32',
    content: 'The moons of what planet are mostly named after Shakespeare characters?',
    date: '1/18',
  },
  {
    id: 'bq_33',
    content: 'What food delivery service is the most widely available? It operates on 6 continents.',
    date: '3/8',
  },
  {
    id: 'bq_34',
    content: 'According to Gallup, what is the most LGBT+ friendly country in the world?',
    date: '3/29',
  },
  {
    id: 'bq_35',
    content: 'What is Activision\'s best-selling video game franchise?',
    date: '4/5',
  },
  {
    id: 'bq_36',
    content: 'Two railroad companies dominate almost all of the railway lines in the US. Name either.',
    date: '4/12',
  },
  {
    id: 'bq_37',
    content: 'What Adobe suite program is best for creating infinitely scalable vector graphics?',
    date: '5/10',
  },
];

export default bonusQuestions;
